import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 bg-secondary-50">
      <div className="w-full px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-lg overflow-hidden bg-background-50">
          <div className="relative min-h-[300px] md:min-h-[400px]">
            <img
              src="https://readdy.ai/api/search-image?query=Korean%20manhwa%20style%20cozy%20reading%20scene%20with%20person%20scrolling%20comics%20on%20tablet%20in%20warm%20lighting%2C%20soft%20ambient%20glow%2C%20comfortable%20setting%2C%20warm%20orange%20and%20cream%20tones%2C%20digital%20illustration%2C%20clean%20composition&width=900&height=500&seq=cta-reading-2026&orientation=landscape"
              alt="韩漫之家阅读体验"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-transparent to-background-50 lg:bg-gradient-to-r lg:from-transparent lg:via-transparent lg:to-background-50"></div>
          </div>

          <div className="flex flex-col items-center justify-center p-8 md:p-12 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 leading-tight">
              准备好开始<br />
              <span className="text-primary-500">你的韩漫之旅</span>了吗？
            </h2>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-md">
              加入韩漫之家，畅享上万部免费韩国漫画。无论是热血战斗还是甜蜜恋爱，下拉式阅读体验让每一页都流畅自然。
            </p>
            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/rexue"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                立即阅读
                <i className="ri-arrow-right-line"></i>
              </Link>
              <Link
                to="/about"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 border border-foreground-300 text-foreground-700 font-medium text-sm rounded-full hover:bg-foreground-100 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}